// PM26 active data — US26/BP26 data files remain in src/data/ as static archive
import programmeringRaw from "../data/pm26-programmering.json";
import inzetRaw from "../data/pm26-inzet.json";
import aandachtRaw from "../data/pm26-aandachtspunten.json";
import locatiesRaw from "../data/pm26-locaties.json";
import type { ProgrammeItem, InzetItem, AandachtItem } from "./types";
import { hhmmToMinutes } from "./time";

export const programmering = programmeringRaw as ProgrammeItem[];
export const inzet = inzetRaw as InzetItem[];
export const aandachtspunten = aandachtRaw as AandachtItem[];
export const locaties = locatiesRaw as Array<{
  venue: string;
  stages: string[];
  id: string;
}>;

// Indexed for performance
export const programmeringByMin = programmering
  .map((p) => ({
    ...p,
    vanMin: hhmmToMinutes(p.tijd_van),
    totMin: hhmmToMinutes(p.tijd_tot),
  }))
  .sort((a, b) => (a.vanMin ?? 9999) - (b.vanMin ?? 9999));

export const showDayInzet = inzet.filter((i) => i.is_show_day);

export const ecc = programmeringByMin.filter((p) => p.is_overleg);

// Group programmering by venue (excluding ECC)
export const venuesPlay = programmeringByMin.filter(
  (p) => p.locatie.venue && p.locatie.venue !== "ECC",
);

// Namen volgens veiligheidsplan PM26 V4 §14.4 (Almeerderstrand).
export const VENUE_LIST = [
  "Area 1 · Mainstage",
  "Area 2 · Blessed",
  "Area 3 · Bresh",
  "Area 4 · Favela",
  "Area 5 · Salsa Madhouse",
] as const;

// Aandachtspunten: split into time-anchored vs document-only
export const aandachtTimed = aandachtspunten.filter(
  (a) => a.kind === "programmering" && a.tijd,
);
export const aandachtDocs = aandachtspunten.filter(
  (a) => a.kind === "document",
);

// Group inzet by sector
export const inzetBySector = (() => {
  const groups: Record<string, InzetItem[]> = {};
  for (const i of showDayInzet) {
    const key = i.sector || "OVERIG";
    (groups[key] ??= []).push(i);
  }
  return groups;
})();
